import React, {Component} from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import { Buffer } from 'buffer';

import { isLogin, logout } from '../../utils';
import ProductItem from '../utils/ProductItem';
import { Route, Redirect } from 'react-router-dom';
import { getCompareCount, getCompare, removefromCompare } from '../../utils/byoscart';
import store, {CART_COUNT_UPDATE, COMPARE_COUNT_UPDATE} from '../../utils/store';
import {connect} from 'react-redux';

class MenuMobile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu:[],
            serviceCheck:false,
        }

        this.handleLogout = this.handleLogout.bind(this);
    }

    async componentDidMount() {
        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('byos_token'));
        try {
            const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/menu',params);
            let resVal=response.data;
            if(resVal.status==='success'){
                this.setState({menu:resVal.data});
                store.dispatch({ type:CART_COUNT_UPDATE, value:resVal.cartCount});
            }
        } catch (error) {
          console.error(error);
        }
        store.dispatch({ type:COMPARE_COUNT_UPDATE, value:getCompareCount()});
    }


    handleLogout(){
        logout();
        this.props.history.push('/');
    }

    getCategoryLabel(category) {
        return category.main_category_name || category.sub_category_name || category.final_category_name || '';
    }

    getCategoryId(category) {
        return category.main_category_id || category.sub_category_id || category.final_category_id || '';
    }

    getChildCategories(category) {
        const subCategories = Array.isArray(category.sub_category_list) ? category.sub_category_list : [];
        const finalCategories = Array.isArray(category.final_category_list) ? category.final_category_list : [];

        return subCategories.length > 0 ? subCategories : finalCategories;
    }

    renderCategoryItems(categories) {
        return categories.map((category, index) => {
            const label = this.getCategoryLabel(category);
            const children = this.getChildCategories(category);
            const categoryId = this.getCategoryId(category);
            const hasChildren = children.length > 0;

            if (hasChildren) {
                return (
                    <li className="menu-item-has-children" key={`${label}-${categoryId || index}`}>
                        <Link to="/" onClick={(event) => event.preventDefault()}>
                            {label}
                        </Link>
                        <span className="sub-toggle"><i className="fa fa-chevron-down"></i></span>
                        <ul className="sub-menu">
                            {this.renderCategoryItems(children)}
                        </ul>
                    </li>
                );
            }

            const categoryPath = `/products/category/${Buffer.from(String(categoryId)).toString('base64')}/${encodeURIComponent(label)}`;

            return (
                <li key={`${label}-${categoryId || index}`}>
                    <Link to={categoryPath}>
                        {label}
                    </Link>
                </li>
            );
        });
    }

    renderProductSubmenu() {
        const menu = Array.isArray(this.props.menu) ? this.props.menu : [];

        return this.renderCategoryItems(menu);
    }


    render() {
        return (
            <div>
                <div className="ps-search">
                <div className="ps-search__content ps-search--mobile"><a className="ps-search__close" href="#" id="close-search"><i className="icon-cross"></i></a>
                    <h3>Search</h3>
                    <form action="#" method="post">
                        <div className="ps-search-table">
                            <div className="input-group">
                                <input className="form-control ps-input" type="text" placeholder="Search for products"/>
                                <div className="input-group-append"><a href="#"><i className="fa fa-search"></i></a></div>
                            </div>
                        </div>
                    </form>
                    <div className="ps-search__result">
                        <div className="ps-search__item">
                            <div className="ps-product ps-product--horizontal">
                                <div className="ps-product__thumbnail"><a className="ps-product__image" href="#">
                                        <figure><img src="assets/img/products/052.jpg" alt="alt" /></figure>
                                    </a></div>
                                <div className="ps-product__content">
                                    <h5 className="ps-product__title"><a>3-layer <span class='hightlight'>mask</span> with an elastic band (1 piece)</a></h5>
                                    <p className="ps-product__desc">Study history up to 30 days Up to 5 users simultaneously Has HEALTH certificate</p>
                                    <div className="ps-product__meta"><span className="ps-product__price">$38.24</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ps-search__item">
                            <div className="ps-product ps-product--horizontal">
                                <div className="ps-product__thumbnail"><a className="ps-product__image" href="#">
                                        <figure><img src="assets/img/products/033.jpg" alt="alt" /></figure>
                                    </a></div>
                                <div className="ps-product__content">
                                    <h5 className="ps-product__title"><a>3 Layer Disposable Protective Face <span class='hightlight'>mask</span>s</a></h5>
                                    <p className="ps-product__desc">Study history up to 30 days Up to 5 users simultaneously Has HEALTH certificate</p>
                                    <div className="ps-product__meta"><span className="ps-product__price sale">$14.52</span><span className="ps-product__del">$17.24</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ps-search__item">
                            <div className="ps-product ps-product--horizontal">
                                <div className="ps-product__thumbnail"><a className="ps-product__image" href="#">
                                        <figure><img src="assets/img/products/051.jpg" alt="alt" /></figure>
                                    </a></div>
                                <div className="ps-product__content">
                                    <h5 className="ps-product__title"><a>3-Ply Ear-Loop Disposable Blue Face <span class='hightlight'>mask</span></a></h5>
                                    <p className="ps-product__desc">Study history up to 30 days Up to 5 users simultaneously Has HEALTH certificate</p>
                                    <div className="ps-product__meta"><span className="ps-product__price sale">$14.99</span><span className="ps-product__del">$38.24</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ps-search__item">
                            <div className="ps-product ps-product--horizontal">
                                <div className="ps-product__thumbnail"><a className="ps-product__image" href="#">
                                        <figure><img src="assets/img/products/050.jpg" alt="alt" /></figure>
                                    </a></div>
                                <div className="ps-product__content">
                                    <h5 className="ps-product__title"><a>Disposable Face <span class='hightlight'>mask</span> for Unisex</a></h5>
                                    <p className="ps-product__desc">Study history up to 30 days Up to 5 users simultaneously Has HEALTH certificate</p>
                                    <div className="ps-product__meta"><span className="ps-product__price sale">$8.15</span><span className="ps-product__del">$12.24</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ps-navigation--footer">
                <div className="ps-nav__item"><a href="#" id="open-menu"><i className="icon-menu"></i></a><a href="#" id="close-menu"><i className="icon-cross"></i></a></div>
                <div className="ps-nav__item"><Link to="/"><i className="icon-home2"></i></Link></div>

                {isLogin()?
                <div className="ps-nav__item"><Link to="/account"><i className="icon-user"></i></Link></div>
                :
                <div className="ps-nav__item"><Link to="/signin"><i className="icon-user"></i></Link></div>
                }
                
                <div className="ps-nav__item"><Link to="/compare"><i class="fa fa-align-left"></i><span className="badge">{this.props.comparecount}</span></Link></div>

                <div className="ps-nav__item"><Link to="/wishlist"><i className="fa fa-heart-o"></i></Link></div>
                <div className="ps-nav__item"><Link to="/cart"><i className="icon-cart-empty"></i><span className="badge">{this.props.count}</span></Link></div>
            </div>
            <div className="ps-menu--slidebar">
                <div className="ps-menu__content">
                    <ul className="menu--mobile">
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/aboutus">About Us</Link></li>
                        <li className="menu-item-has-children">
                            <Link to="/" onClick={(event) => event.preventDefault()}>
                                Products
                            </Link>
                            <span className="sub-toggle"><i className="fa fa-chevron-down"></i></span>
                            <ul className="sub-menu">
                                {this.renderProductSubmenu()}
                            </ul>
                        </li>
                        <li><Link to="/contactus">Contact us</Link></li>

                    </ul>

                </div>
               
            </div>
            </div>
        );
    }
}

const mapStatetoPropsMobile = (state) => {
    return{
        count: state.cart.count,
        comparecount: state.compare.count,
    }
}

export default connect(mapStatetoPropsMobile,null)(MenuMobile);
